<template>
  <div class="Steps">
    {{ $t('common.navStep.step', 'step') }}
    <span class="Step_number">{{ stepNumer }}</span>
    {{ $t('common.navStep.of', 'of') }}
    <span class="Step_count"> {{ stepCount }}</span>
  </div>
</template>

<script>
  export default {
    name: 'checkout-nav',

    props: {
      stepNumer: {
        type: Number,
        required: true
      },
      stepCount: {
        type: Number,
        default: 3
      }
    }
  }
</script>

<style lang="scss">
  .Steps {
    font-size: .12rem;
  }
</style>
